import React, { useEffect, useState } from 'react';
import { View } from 'react-native';

import { MEASUREMENT_UNIT_SHORT_NAME } from '../../../common/constants';
import { shouldApplyDynamicParlevels } from '../../../common/utils/planograms/dynamicParlevels';
import useDialogSaveButton from '../../hooks/useDialogSaveButton';
import { InputNumber } from '../../components/input';
import { Text } from '../../components';
import { PrimaryButton } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const MachineValuesEdit = ({
	planogramItem,
	setPlanogramItemValue,
	isMarket,
	pos,
}) => {
	const styles = useThemedStyles(createStyles);

	const isParlevelLocked = shouldApplyDynamicParlevels(planogramItem, pos);
	const { isSaveButtonPressed, onSaveButtonPress } = useDialogSaveButton();

	const [autoFocus, setAutoFocus] = useState(!isParlevelLocked);
	useEffect(() => {
		setAutoFocus(false);
	}, []);

	return (
		<View style={styles.container}>
			<Text style={styles.title}>{ !isMarket && `${planogramItem.selection}. `}{planogramItem.product?.name}</Text>

			<View style={styles.row}>
				<View style={styles.field}>
					<Text style={styles.label}>Before</Text>
					<InputNumber
						autoFocus={autoFocus}
						disabled={isParlevelLocked}
						product={planogramItem.product}
						suffix={planogramItem.product && MEASUREMENT_UNIT_SHORT_NAME[planogramItem.product.measurementUnit]}
						onChange={(value) => setPlanogramItemValue(planogramItem.id, 'productQuantityPreService')(Math.max(0, value))}
						value={planogramItem.productQuantityPreService}
					/>
				</View>

				<View style={styles.field}>
					<Text style={styles.label}>After</Text>
					<InputNumber
						product={planogramItem.product}
						suffix={planogramItem.product && MEASUREMENT_UNIT_SHORT_NAME[planogramItem.product.measurementUnit]}
						onChange={(value) => setPlanogramItemValue(planogramItem.id, 'presentProductQuantity')(value)}
						value={planogramItem.presentProductQuantity}
					/>
				</View>
			</View>

			<PrimaryButton
				size="compact"
				label="OK"
				loading={isSaveButtonPressed}
				onPress={onSaveButtonPress}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		gap: space.md,
	},
	title: {
		...type.rowTitleSemibold,
		color: colors.text,
		// Keep clear of the dialog's close button.
		paddingRight: 36,
	},
	row: {
		flexDirection: 'row',
		gap: space.sm,
	},
	field: {
		gap: space.xs,
	},
	label: {
		...type.caption,
		color: colors.textSecondary,
	},
});


export default React.memo(MachineValuesEdit);
